<template>
  <div class="has-text-centered" style="position:relative">
     <!-- The video -->
    <progress class="progress progress-1 is-primary m-b-none" :value="currentTime" :max="fullTime"></progress>
    <Video ref="vid" @click="playPause" :viewmode="currentWorkout.mode || 'vimeo'" :src="currentWorkout.vidpath === undefined ? 'http://assets.keepyou.fit/fitness/vid/'+currentWorkout.vidname+'.mp4' : currentWorkout.vidpath" :poster="currentWorkout.preview" style="margin:0 auto;">
      <div class="workout-top-left-m has-text-left">
        <p class="is-size-4 has-text-primary">{{ currentWorkout.name }}</p>
      </div>
    </Video>
    <progress :class="'progress is-primary m-b-sm ' + progressClass" :value="time" :max="workoutTime"></progress>
    <span @click="step(5)" v-if="workoutTime - time > 5" :class="($store.getters.isMH ? ' has-text-grey' : ' has-text-light') + ' icon is-size-2'" style="position: absolute; bottom: 1.25rem;right:5rem;">
      <i class="fa fa-forward"></i>
    </span>
    <span v-if="time > 5" @click="step(-5)" :class="($store.getters.isMH ? ' has-text-grey' : ' has-text-light') + ' icon is-size-2'" style="position: absolute; bottom: 1.25rem;left:5rem;">
      <i class="fa fa-backward"></i>
    </span>
    <span @click="forward" :class="($store.getters.isMH ? ' has-text-grey' : ' has-text-light') + ' icon is-size-2'" style="position: absolute; bottom: 1.25rem;right:2rem;">
      <i class="fa fa-step-forward"></i>
    </span>
    <span v-if="current > 0" @click="backward" :class="($store.getters.isMH ? ' has-text-grey' : ' has-text-light') + ' icon is-size-2'" style="position: absolute; bottom: 1.25rem;left:2rem;">
      <i class="fa fa-step-backward"></i>
    </span>
  </div>
</template>

<script>
import Video from '@/components/Settings/VideoM'

export default {
  name: 'Showcase',
  props: ['list', 'rep'],
  data () {
    return {
      playing: false,
      counter: false,
      time: 0,
      interval: undefined,
      currentTime: 0,
      current: 0,
      reps: this.rep * this.list.length,
      progressClass: this.$i18n.locale() === 'my' ? 'progress-2-my' : 'progress-2',
    }
  },
  computed: {
    currentWorkout() {
      return this.list[this.current % this.list.length]
    },
    workoutTime() {
      return this.currentWorkout.duration
    },
    fullTime() {
      return this.list.reduce((sum, item) => sum + item.duration, 0) * this.rep
    },
    prevTime() {

    }
  },
  methods: {
    start () {
      this.time = 0
      this.repLength = this.config.repetitions[this.rep]
      this.play()
    },
    play () {
      this.$refs.vid.play()
      this.playing = true
      this.$emit('playing', true)
      this.interval = setInterval(this.go, 1000)
    },
    forward () {
      this.currentTime += this.workoutTime - this.time
      this.current++
      this.go()
      this.time = 0
      if (this.playing) {
        this.pause()
      }
    },
    step (n) {
      this.time += n
      this.$refs.vid.move(n)
    },
    backward () {
      this.currentTime -= this.time
      this.current--
      this.currentTime -= this.workoutTime
      this.time = 0
    },
    pause () {
      clearInterval(this.interval)
      this.playing = false
      this.$emit('playing', false)
      this.$refs.vid.pause()
    },
    playPause () {
      if (this.playing) {
        this.pause()
      } else {
        this.play()
      }
    },
    menu () {
      this.playing = false
      this.$emit('playing', false)
      this.$refs.vid.pause()
      clearInterval(this.interval)
      this.$emit('menu')
    },
    skipWait () {
      this.run = false
      this.$refs.vid.pause()
    },
    waitEnd () {
      this.start()
    },
    end () {
      this.rep = 0
      this.run = false
      this.wait = false
      this.$refs.vid.stop()
      this.$emit('end')
    },
    go() {
      this.time++
      this.currentTime++
      if (this.time >= this.currentWorkout.duration) {
        this.pause()
        this.current++
        this.counter = true
        this.time = 0
      } else {
        this.counter = false
      }

      if (this.current < this.reps) {
        this.$emit('progress', {
          currentTime: this.currentTime,
          currentWorkoutTime: this.time,
          workoutTime: this.currentWorkout.duration,
          current: this.current,
          fullTime: this.fullTime,
          reps: this.allRepetitions,
          rep: this.repetitions,
          playing: this.playing,
          counter: this.counter
        })
      } else {
        this.$emit('end')
      }
    }
  },
  components: {
    Video
  }
}
</script>

<style>
.workout-top-left-m {
  position: absolute;
  top: 1rem;
  left: 1rem;
}
.workout-top-right-m {
  position: absolute;
  top: 1rem;
  right: 1rem;
}
.workout-bottom-m {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
}
.workout-mitte-m {
  position: absolute;
  top: 50%;
  left: 50%;
  margin-left: -2rem;
  margin-top: -2rem;
  width: 4rem;
}
.workout-bottom-m .progress {
  border-radius: 0;
  height: 2rem;
  opacity: 0.5;
}
.progress-top-m {
  position: absolute;
  top:0;
  left:0;
  width: 100%;
  opacity: 0.5;
  height: 0.4rem;
  border-radius: 0;
  background:transparent;
  border:none
}

.progress-1 {
  border-radius: 0;
  height: 1.5rem;
  opacity: 0.5;
}
.progress-2 {
  border-radius: 0;
  height: 4rem;
  opacity: 0.5;
}
.progress-2-my {
  border-radius: 0;
  height: 4rem;
  opacity: 0.99;
}
.progress-2-my::-moz-progress-bar,
.progress-2-my::-webkit-progress-bar {
  background-color: #fddbb0 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/Settings/WorkoutM.vue